import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropDownModule } from '@shared/core/components/dropDown';
import { LinkModule } from '@shared/core/components/link';
import { IconModule } from '@shared/core/components/icon';
import { ButtonsModule } from '@shared/core/components/buttons';
import { PickupLabelPipeModule } from '@shared/core/pipes/pickupLabel';
import { PickupButtonComponent } from './pickup-button.shared.component';

@NgModule({
    declarations: [
        PickupButtonComponent
    ],
    imports: [
        CommonModule,
        DropDownModule,
        ButtonsModule,
        LinkModule,
        IconModule,
        PickupLabelPipeModule,
    ],
    exports: [
        PickupButtonComponent
    ],
})
export class PickupButtonModule { }
